var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    { class: _vm.$style.contentButton, attrs: { tabindex: "0" } },
    [
      _vm.type === "add"
        ? _vm._m(0)
        : _vm.type === "remove"
        ? _vm._m(1)
        : _vm.type === "import"
        ? _vm._m(2)
        : _vm._e(),
      _vm.label
        ? _c("div", { class: _vm.$style.text }, [
            _vm._v(" " + _vm._s(_vm.label) + " "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { class: _vm.$style.icon }, [_c("IconAdd")], 1)
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { class: _vm.$style.icon }, [_c("IconRemove")], 1)
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { class: _vm.$style.icon }, [_c("IconImport")], 1)
  },
]
render._withStripped = true

export { render, staticRenderFns }